import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const FitToFrameIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        d="M5.00004 2L5.00002 4.99996H2.00004L2 2H5.00004Z"
        fill="currentColor"
      />
      <path
        d="M14 11C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7C12.8955 7 12 7.89543 12 9C12 9.1518 12.0169 9.29965 12.049 9.44177L10.3076 10.4866C9.95698 10.1834 9.49992 10 9.00002 10C7.89546 10 7.00002 10.8954 7.00002 12C7.00002 13.1046 7.89546 14 9.00002 14C9.4999 14 9.95693 13.8166 10.3075 13.5135L12.049 14.5583C12.0169 14.7004 12 14.8482 12 15C12 16.1046 12.8955 17 14 17C15.1046 17 16 16.1046 16 15C16 13.8954 15.1046 13 14 13C13.5001 13 13.043 13.1834 12.6924 13.4866L10.9511 12.4418C10.9831 12.2997 11 12.1518 11 12C11 11.8482 10.9831 11.7004 10.9511 11.5582L12.6925 10.5134C13.0431 10.8166 13.5001 11 14 11Z"
        fill="currentColor"
      />
      <path d="M22 5L22 2H19L19 5H22Z" fill="currentColor" />
      <path d="M22 22H19V19H22V22Z" fill="currentColor" />
      <path d="M2.00004 22H5V19H2L2.00004 22Z" fill="currentColor" />
      <path d="M6.00002 3H18V4H6.00002V3Z" fill="currentColor" />
      <path d="M4.00002 6V18H3.00002V6H4.00002Z" fill="currentColor" />
      <path d="M18 21V20H6.00002V21H18Z" fill="currentColor" />
      <path d="M21 6H20V18H21V6Z" fill="currentColor" />
    </IconBase>
  );
};

export default FitToFrameIcon;
